import { all, call, put, take } from 'redux-saga/effects';
import { get } from 'lodash';
import { notification } from 'antd';

import {
  UPDATE_APPOINTMENT_NOTE,
  UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT,
} from '../type';
import {
  updateAppointmentNoteErrorAction,
  updateAppointmentNoteSuccessAction,
  updateAppointmentNoteAndCreateAccountErrorAction,
  updateAppointmentNoteAndCreateAccountSuccessAction,
} from '../action';

import MessengerResource from 'common/resource/MessengerResource';

import { appointmentService, accountService } from 'services';

function* updateAppointmentNote() {
  while (1) {
    const action = yield take(UPDATE_APPOINTMENT_NOTE);
    try {
      const callback = get(action, 'payload.callback');
      const response = yield call(
        appointmentService.updateAppointmentNode,
        action.payload,
      );

      callback && callback(response);
      yield put(updateAppointmentNoteSuccessAction(response));
    } catch (error) {
      notification.error({
        message: MessengerResource.thankYou.updateNoteError,
        description: error.message,
      });
      yield put(updateAppointmentNoteErrorAction(error));
    }
  }
}

function* updateAppointmentNoteAndCreateAccount() {
  while (1) {
    const action = yield take(UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT);

    const callback = get(action, 'payload.callback');
    const noteData = get(action, 'payload.data.note');
    const accountData = get(action, 'payload.data.account');

    let appointmentNoteResponse = null;
    let accountResponse = null;
    try {
      if (noteData) {
        appointmentNoteResponse = yield call(
          appointmentService.updateAppointmentNode,
          noteData,
        );
      }
    } catch (error) {
      notification.error({
        message: MessengerResource.thankYou.updateNoteError,
        description: error.message,
      });
      yield put(updateAppointmentNoteAndCreateAccountErrorAction(error));
    }

    try {
      if (accountData) {
        accountResponse = yield call(
          accountService.createPatientAccount,
          accountData,
        );
      }

      const response = {
        note: appointmentNoteResponse,
        account: accountResponse,
      };

      callback && callback(response);
      yield put(updateAppointmentNoteAndCreateAccountSuccessAction(response));
    } catch (error) {
      notification.error({
        message: MessengerResource.thankYou.createAccountErr,
        description: error.message,
      });
      yield put(updateAppointmentNoteAndCreateAccountErrorAction(error));
    }
  }
}

export default function* rootSaga() {
  yield all([updateAppointmentNote(), updateAppointmentNoteAndCreateAccount()]);
}
